import React from 'react';
import {IndexRoute, Route} from 'react-router';
import {ZadostNalezitosti, ZadostShrnuti, ZadostTyp, ZadostZakres} from './components';
import {App, HomePage, Layout, LoginPage, PasswordResetPage, UserProfilePage, WelcomePage} from './containers';

export default (
    <Route path={serverContextPath} component={App}>
        <Route path={serverContextPath === "" ? "/" : ""} component={Layout}>
            <IndexRoute component={HomePage}/>
        </Route>
        <Route path="password-reset" component={PasswordResetPage}/>
        <Route path="welcome" component={WelcomePage}/>
        <Route path="login" component={LoginPage}/>
        <Route path="zadost" component={Layout}>
            <IndexRoute component={ZadostTyp}/>
        </Route>
        <Route path="user" component={Layout}>
            <Route path="profile" component={UserProfilePage}/>
        </Route>
        <Route path="zadost/:id" component={Layout}>
            <Route path="typ" component={ZadostTyp}/>
            <Route path="nalezitosti" component={ZadostNalezitosti}/>
            <Route path="zakres" component={ZadostZakres}/>
            <Route path="shrnuti" component={ZadostShrnuti}/>
        </Route>
    </Route>
);
